<div class="page-layout simple full-width">

    <!-- HEADER -->
    <div class="header p-24 pb-0" fxLayout="row" fxLayoutAlign="space-between center">

        <div fxLayout="column" fxLayoutAlign="center start" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
            <div class="h2 mt-5"> Productos Relacionados: {{ item.id }} {{ item.title }} </div>
        </div>

        <button mat-button [routerLink]="'/' + pathUrlList" class="mt-0 mt-md-0">
            <mat-icon>arrow_back</mat-icon>
            <span>Volver</span>
        </button>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content">

        <!-- CENTER -->
        <div class="center p-24 pb-56" fusePerfectScrollbar>



            <!-- CONTENT -->
            <div class="content">

                <div class="container-table">
                    <mat-table #table [dataSource]="dataItems.data" [@animateStagger]="{value:'50'}">

                        <ng-container *ngFor="let column of configColumns" [matColumnDef]="column.key">
                            <!-- TH -->
                            <mat-header-cell *matHeaderCellDef>{{ column.title }}</mat-header-cell>

                            <!-- TD -->
                            <mat-cell *matCellDef="let child">

                                <ng-container *ngIf="column.type == 'integer' || column.type == 'string'">
                                    <p [ngClass]="{'text-truncate': column.type == 'integer'}" class="{{ column.classes }}">{{ child[column.field_key] }}</p>
                                </ng-container>

                            </mat-cell>
                            
                            
                        </ng-container>

                        <ng-container [matColumnDef]="'product'">
                            <!-- TH -->
                            <mat-header-cell *matHeaderCellDef>Producto</mat-header-cell>

                            <!-- TD -->
                            <mat-cell *matCellDef="let child">

                                <ng-container>
                                    <p class="">{{ child.related.title }}</p>
                                </ng-container>

                            </mat-cell>
                            
                            
                        </ng-container>
                        

                        <!-- Buttons Column -->
                        <ng-container matColumnDef="actions" stickyEnd>
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let child">
                                <div fxFlex="row" fxLayoutAlign="end center">

                                    <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="Acciones" (click)="$event.stopPropagation();">
                                        <mat-icon class="secondary-text">more_vert</mat-icon>
                                    </button>

                                    <mat-menu #moreMenu="matMenu">
                                        <button mat-menu-item aria-label="remove" [swal]="{ title: 'Eliminar ' + child.id, text: '¿Se encuentra seguro de eliminar?', type: 'warning', focusCancel: true, showCancelButton: true, confirmButtonText: 'Eliminar', cancelButtonText: 'Cancelar' }"
                                            (confirm)="onRemove(child)">
                                                <mat-icon>delete</mat-icon>
                                                <span>Eliminar</span>
                                            </button>
                                    </mat-menu>
                                </div>

                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                        <mat-row *matRowDef="let child; columns: displayedColumns;" class="item" (click)="openItem(child)" matRipple [@animate]="{value:'*',params:{y:'100%'}}">
                        </mat-row>
                    </mat-table>
                </div>

                <mat-card *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center">
                    <mat-progress-spinner color="primary" mode="indeterminate">
                    </mat-progress-spinner>
                </mat-card>

            </div>
            <!-- / CONTENT -->

            <div class=" p-24">
                <div class="h2 mt-5">Agregar nuevo item:</div>
            </div>
            

            <div class="content">
                <form *ngIf="!isLoading" class="mat-card mat-elevation-z4 p-24" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="form">

                    <ng-container *ngFor="let field of configFields">
    
                        <mat-form-field *ngIf="field.type == 'string'" appearance="outline" class="pl-4">
                            <mat-label>{{ field.title }}</mat-label>
                            <input matInput [name]="field.key" [(ngModel)]="newItem[field.key]" />
                        </mat-form-field>
    
                        <mat-form-field  *ngIf="field.type == 'select'" appearance="outline" fxFlex="80">
                            <mat-label>{{ field.title }}</mat-label>
                            <mat-select name="parent_id" [(ngModel)]="newItem[field.key]">
                                <mat-option *ngFor="let opt of field.options" [value]="opt.value">
                                    {{ opt.title }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
    
                        <mat-form-field *ngIf="field.type == 'text'" appearance="outline" class="pl-4">
                            <mat-label>{{ field.title }}</mat-label>
                            <textarea matInput [name]="field.key" [(ngModel)]="newItem[field.key]"></textarea>
                        </mat-form-field>
    
                    </ng-container>
    
                    <!--<mat-form-field appearance="outline" fxFlex="80">
                        <mat-label>Seleccionar padre:</mat-label>
                        <mat-select name="parent_id" [(ngModel)]="category.parent_id">
                            <mat-option [value]="0">Ninguno</mat-option>
                            <mat-option *ngFor="let comp of categories" [value]="comp.id">
                                {{ comp.title }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>-->
    
                    
    
                    <mat-progress-bar *ngIf="isSending" mode="buffer"></mat-progress-bar>
    
                    <div *ngIf="!isSending" fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <button [routerLink]="'/' + pathUrlList" mat-raised-button color="warn" class="mt-24 mt-md-0 mr-4">
                            <span>Cancelar</span>
                        </button>
    
                        <button type="button" (click)="onClickSave()" mat-raised-button color="primary" class="mt-24 mt-md-0">
                            <span>Guardar y volver</span>
                        </button>
                    </div>
    
    
    
                </form>
    
            </div>

        </div>
        <!-- / CENTER -->

    </div>
    <!-- / CONTENT-->

</div>